import React from "react"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { CopyIconButton } from "@/components/copy-icon-button"
import { PasswordTextField } from "@/components/form/password-text-field/password-text-field"
import { FormTextField } from "@/nzds/forms/form-text-field/form-text-field"

import InputAdornment from "@mui/material/InputAdornment"

interface CredentialSecretFieldsValues {
  password: string
  username: string
}

export const CredentialSecretFields: React.FC = () => {
  const { t } = useTranslation("common")
  const form = useFormContext<CredentialSecretFieldsValues>()
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false)
  const watchedPassword = form.watch("password")
  const watchedUsername = form.watch("username")

  return (
    <>
      <FormTextField<CredentialSecretFieldsValues>
        label={t("admin.credentialsUi.usernameLabel")}
        name="username"
        required
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <CopyIconButton
                  ariaLabel={t("admin.credentialsUi.copyUsernameAriaLabel")}
                  edge="end"
                  value={watchedUsername}
                />
              </InputAdornment>
            ),
          },
        }}
        variant="stacked"
      />
      <PasswordTextField<CredentialSecretFieldsValues>
        id="password"
        isPasswordVisible={isPasswordVisible}
        label={t("fields.password.title")}
        onPasswordVisibleClick={() => {
          setIsPasswordVisible((currentValue) => !currentValue)
        }}
        required
        rightAdornment={
          <CopyIconButton
            ariaLabel={t("admin.credentialsUi.copyPasswordAriaLabel")}
            edge="end"
            value={watchedPassword}
          />
        }
        variant="stacked"
      />
    </>
  )
}
